import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Catalogo from './pages/Catalogo';
import DetalleProducto from './pages/DetalleProducto';
import GraciasSuscripcion from './pages/GraciasSuscripcion';
import Registro from './pages/Registro';
import Login from './pages/Login';
import MiCuenta from './pages/MiCuenta';
import OlvideMiContrasena from './pages/OlvideMiContrasena';
import RestablecerContrasena from './pages/RestablecerContrasena';
import PedidoConfirmado from './pages/PedidoConfirmado';
import RequireCustomer from './components/RequireCustomer';
import { FrontendLayout } from './components/FrontendLayout';
import { ToastProvider } from './components/ui/Toast';

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

// Componente para restaurar el scroll al inicio en cada cambio de ruta
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll inmediato al inicio de la página
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8">
          <p className="font-heading text-lg font-semibold text-slate-800">Algo salió mal</p>
          <p className="text-sm text-slate-500 max-w-sm text-center">
            {error instanceof Error ? error.message : 'Error desconocido'}
          </p>
          <button
            onClick={resetError}
            className="px-4 py-2 rounded-full bg-brand-primary text-white text-sm font-medium hover:bg-brand-primary-hover transition-colors"
          >
            Reintentar
          </button>
        </div>
      )}
    >
      <ScrollToTop />
      <ToastProvider />
      <SentryRoutes>
        <Route path="/gracias-suscripcion" element={<GraciasSuscripcion />} />
        <Route element={<FrontendLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/producto/:id" element={<DetalleProducto />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/login" element={<Login />} />
          <Route path="/olvide-mi-contrasena" element={<OlvideMiContrasena />} />
          <Route path="/restablecer-contrasena" element={<RestablecerContrasena />} />
          <Route element={<RequireCustomer />}>
            <Route path="/mi-cuenta" element={<MiCuenta />} />
            <Route path="/pedido/:id" element={<PedidoConfirmado />} />
          </Route>
        </Route>
      </SentryRoutes>
    </Sentry.ErrorBoundary>
  );
}
